import axios from 'axios';
import getpppData from './getPPPData';
import getUserData from './getUserData';
import { cpApiUrl } from '../config/SiteConfig';

export default async () => {
	if (!window.pppCoupon) {
		const userData = await getUserData();
		const pppData = await getpppData();

		// Fetch discount.
		if (pppData.discount > 0) {
			const res = await axios({
				method: 'post',
				url: cpApiUrl,
				data: {
					do: 'pppCoupon',
					country: userData.country,
				},
			});

			window.pppCoupon = res.data.coupon;
		} else {
			window.pppCoupon = false;
		}
	}

	// Return it.
	return window.pppCoupon;
};
